module.exports = __webpack_public_path__ + "dashboard/img/keyboard.7b779c419dd49617cd5414ddd31ac534.svg";